export default "__VITE_ASSET__DMBMN0DM__"